export const hexColorCheck = (color: string): string => {
  const checkHexColorRegex = /^#([0-9a-f]{3}){1,2}$/i;

  if (checkHexColorRegex.test(color)) {
    return color;
  }

  return "#000100";
};
